<template>
    <div >
        <Card>
            <p slot="title">
                Marking Group
            </p>
                <Button
                    v-show="canCreateMarkingGroup()"
                    type="primary"
                    slot="extra"
                    @click="modal.createMarkingGroup=true"
                    size="small"  >
                    Tambah
                </Button>
                <template>
                    <Table border :columns="columnTablemarkingGroup" :data="markingGroup"></Table>
                </template>
        </Card>
        <template>
            <Modal v-model="modal.createMarkingGroup" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Tambah Marking Group</span>
                </p>
                <Form ref="formMarkingGroup" :model="formMarkingGroup" :rules="ruleValidate">
                    <Form-item label="Group Name" prop="groupName">
                        <Input v-model="formMarkingGroup.groupName" placeholder="Group Name"></Input>
                    </Form-item>
                    <Form-item>
                        <Select
                            placeholder="Ketik Marking"
                            v-model="formMarkingGroup.markings"
                            filterable
                            multiple
                            :remote-method="getMarkingByCode"
                            :loading="loadingGetMarking">
                            <Option v-for="(option, index) in optionMarkings"
                                :value="option.value" :key="index">{{option.label}}</Option>
                        </Select>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingcreateMarkingGroup"
                        @click="postcreateMarkingGroup" >
                        <span v-if="!loadingcreateMarkingGroup">Simpan</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>
        <template>
            <Modal v-model="modal.editmarkingGroup" width="500px">
                <p slot="header" style="color:#2d8cf0;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Edit Marking Group</span>
                </p>
                <Form ref="formEditMarkingGroup" :model="formEditMarkingGroup" :rules="ruleValidate">
                    <Form-item label="Group Name" prop="groupName">
                        <Input style="display: none;" v-model="formEditMarkingGroup.id" placeholder="Id Group Name"></Input>
                        <Input v-model="formEditMarkingGroup.groupName" placeholder="Group Name"></Input>
                    </Form-item>
                    <Form-item>
                        <Select
                            placeholder="Ketik Marking"
                            v-model="formEditMarkingGroup.markingSelected"
                            filterable
                            multiple
                            :remote-method="getMarkingByCode"
                            :loading="loadingGetMarking">
                            <Option v-for="(option, index) in optionMarkings"
                                :value="option.label" :key="index">{{option.label}}</Option>
                        </Select>
                    </Form-item>
                </Form>
                <div slot="footer">
                    <Button
                        v-show="true"
                        type="primary"
                        :loading="loadingEditmarkingGroup"
                        @click="postEditmarkingGroup" >
                        <span v-if="!loadingEditmarkingGroup">Edit</span>
                        <span v-else>Wait.....</span>
                    </Button>
                </div>
            </Modal>
        </template>

        <!-- Modal delete payment -->
        <Modal v-model="isModalDelete" ok-text="Ya" cancel-text="Tidak" @on-cancel="confirmDescription = ''">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>
            <br/>
            <div>
                <h4>GROUP NAME : {{formDeleteMarkingGroup.groupName}}</h4> <hr/>
                <div>
                  <b> MARKING : </b>
                  <span v-for="(marking, index) in formDeleteMarkingGroup.detail">
                      <Tag>{{ marking.markingheadercode }}</Tag>
                  </span>
                </div> <br/>
                <i> Ketik <b>{{ formDeleteMarkingGroup.groupName }}</b> untuk melanjutkan !</i>

                <Input v-model="formDeleteMarkingGroup.id" style="display: none;"></Input>
                <Input v-model="formDeleteMarkingGroup.groupName" style="display: none;"></Input>
                <Input v-model="confirmDescription" />
            </div>

            <div slot="footer">
                <Button type="error" long v-show="(formDeleteMarkingGroup.groupName).toUpperCase() == confirmDescription.toUpperCase()" @click="deleteMarkingGroup">Hapus</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'

export default {
    data () {
        return {
            user : {
                username : '',
                role : ''
            },
            modal : {
                createMarkingGroup : false,
                editmarkingGroup : false,
            } ,
            loadingSearch: false,
            loadingcreateMarkingGroup: false,
            loadingEditmarkingGroup: false,
            markingGroup : [],
            markingIdSelected : [],
            optionMarkings : [],
            selected: [],
            formMarkingGroup: {
                groupName: '',
                markings: []
            },
            formEditMarkingGroup: {
                id: Number,
                groupName: '',
                markingSelected: []
            },
            isModalDelete: false,
            confirmDescription: '',
            formDeleteMarkingGroup: {
                id: Number,
                groupName: '',
                detail: []
            },
            ruleValidate: {
                groupName: [
                    { required: true, message: 'Masukkan Group Name', trigger: 'blur' }
                ],
            },
            columnTablemarkingGroup: [
                {
                    title: 'Group Name',
                    key: 'code'
                },
                {
                    // type: 'html',
                    title: 'Markings',
                    key: 'markingheadercodes',
                    render: (h, params) => {
                        let buttonToShow = [];
                        // let index = 1;

                        _.forEach(params.row.detail, function(detail) {
                            // if (index > 3) {
                            //     buttonToShow.push(
                            //         h('Tooltip', {
                            //             props: {
                            //                 placement: 'right',
                            //                 name: 'true',
                            //                 maxWidth: 220,
                            //                 content: detail
                            //             },
                            //         }, '...')
                            //     );

                            //     return
                            // }

                            buttonToShow.push(
                                h('Button', {
                                    props: {
                                        type: 'default',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                }, detail.markingheadercode)
                            );

                            // index++;
                        });

                        return h('div', buttonToShow);
                    }
                },
                {
                    title: 'Action',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.show(params.index)
                                    }
                                }
                            }, 'Edit'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.showModalDelete(params.index)
                                    }
                                }
                            }, 'Delete')
                        ]);
                    }
                }
            ],
        }
    },

  methods: {
    canCreateMarkingGroup () {
        let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'ADMIN-SUPER'], this.user.role);
        //console.log('this.user.role = ' + this.user.role)
        //console.log('canAccess = ' + canAccess)
        return canAccess;
    },
    handleSubmit (name) {
        this.$refs[name].validate((valid) => {
            if (valid) {
                this.createMarkingGroup();
            } else {
                this.$Message.error('Data masih belum lengkap');
            }
        })
    },
    show: function(index){
        let markingList = [];
        let markingSelected = [];

        this.formEditMarkingGroup.id = this.markingGroup[index].id;
        this.formEditMarkingGroup.groupName = this.markingGroup[index].code;

        // set selected marking group editing
        _.forEach(this.markingGroup[index].detail, function(detail) {
            let listTemp = {
                value: detail.markingheadercode,
                label: detail.markingheadercode
            }

            markingList.push(listTemp);
            markingSelected.push(detail.markingheadercode);
        })

        this.optionMarkings = markingList;
        this.formEditMarkingGroup.markingSelected = markingSelected;

        this.modal.editmarkingGroup = true;
    },
    getMarkingGroup: function(){
        this.loadingSearch  = true;
        this.markingGroup = [];
        HTTP
            .get('markingGroup/getAll')
            .then(response => {
                console.log({response});
                let formattedResponse = [];

                this.loadingSearch  = false;

                _.forEach(response.data, function(data) {
                    let markingheadercodes = '';

                    _.forEach(data.detail, function(detail) {
                        let markingheadercode = detail.markingheadercode + ' ~ ';
                        markingheadercodes += markingheadercode;
                    });

                    let tempResponse = {
                        id : data.id,
                        code : data.code,
                        detail : data.detail,
                        markingheadercodes : markingheadercodes
                    }

                    formattedResponse.push(tempResponse);
                });

                console.log({formattedResponse});
                this.markingGroup = formattedResponse;
            })
            .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
            });
        })
    },
    getMarkingByCode: _.debounce(
        function (query) {
            if (query !== '') {
                this.loadingGetMarking = true;
                HTTP
                // .post('marking/getByCodeAll', {
                .post('marking/getBySnapshot', {
                    markingHeaderId: query,
                    subbranchcode: this.subbranchcode
                })
                .then(response => {

                    this.invoiceDues = []
                    this.amountResidue = ''
                    this.amountReceived = ''
                    this.description = ''

                    this.loadingGetMarking = false;
                    let data = response.data;

                    const list = data.map(item => {
                        return {
                            value: item.markingheaderid,
                            label: item.markingheadercode
                        };
                    });

                    this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                })
                .catch(e => {
                    this.loadingGetMarking = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            } else {
                this.optionMarkings = [];
            }
        }, 400
    ),
    postcreateMarkingGroup:function(){
        this.loadingcreateMarkingGroup = true;

        let groupNameExist = _.some(this.markingGroup, {groupName: this.formMarkingGroup.groupName });

        if(groupNameExist){
            this.$Message.error('Group name sudah ada');
            this.loadingcreateMarkingGroup = false;
            return false;
        }

        console.log(this.formMarkingGroup.markings)

        HTTP
        .post('markingGroup/create', {
            groupName: this.formMarkingGroup.groupName,
            markings: this.formMarkingGroup.markings
        })
        .then(response => {
            this.loadingcreateMarkingGroup = false;
            this.modal.createMarkingGroup = false;
            this.formMarkingGroup.groupName = '';

            this.$Message.success('Marking Group Created');
            this.getMarkingGroup();
        })
        .catch(e => {
            this.loadingcreateMarkingGroup = false;
            this.$Notice.error({
                title: "Error",
                desc:e,
                duration: 5
            });
        })
        this.formMarkingGroup.markings = null;
    },
    postEditmarkingGroup:function(){
        this.loadingEditmarkingGroup = true;

        let groupNameExist = _.some(this.markingGroup, {groupName: this.formEditMarkingGroup.groupName});

        if(groupNameExist){
            this.$Message.error('Dept name sudah ada');
            this.loadingEditmarkingGroup = false;
            return false;
        }

        HTTP
        .post('markingGroup/update', {
            id: this.formEditMarkingGroup.id,
            groupName: this.formEditMarkingGroup.groupName,
            markings: this.formEditMarkingGroup.markingSelected
        })
        .then(response => {
            this.loadingEditmarkingGroup = false;
            this.modal.editmarkingGroup = false;
            this.formEditMarkingGroup.groupName = '';

            this.$Message.success('Item Dept Edited');
            this.getMarkingGroup();
        })
        .catch(e => {
            this.loadingEditmarkingGroup = false;
            this.$Notice.error({
                title: "Error",
                desc:e,
                duration: 5
            });
        })
    },
    showModalDelete: function(index){
        let rowData = this.markingGroup[index];

        console.log({rowData});

        this.formDeleteMarkingGroup.id = rowData.id;
        this.formDeleteMarkingGroup.groupName = rowData.code;
        this.formDeleteMarkingGroup.detail = rowData.detail;

        this.isModalDelete = true;
    },
    deleteMarkingGroup: function(){
        this.$Loading.start();

        let payload = {
            markingGroupId: this.formDeleteMarkingGroup.id,
        }

        // console.log({payload});

        HTTP
        .post('markingGroup/delete', payload)
        .then(response => {
            console.log("post delete response :", response);

            this.isModalDelete = false;
            this.$Loading.finish();
            this.$Message.success('Marking group has been deleted !');

            this.getMarkingGroup();
        })
        .catch(e => {
            this.$Notice.error({
                title: "Error",
                desc:e,
                duration: 5
            });
        })
    },
  },
  created() {
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
      this.getMarkingGroup();
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// MarkingGroup.vue?0031f7a6